'use client';

import React from 'react';

import FooterActionButton from '@/components/atoms/Button/FooterActionButton/FooterActionButton';

interface FilterFooterActionsProps {
  /** Clears the current selection. */
  onClear: () => void;
  /** Confirms / applies the current selection. */
  onApply: () => void;
  /** Text size passthrough — see FooterActionButton. */
  size?: 'body' | 'footer';
  /** Optional weight overrides per action. */
  clearWeight?: 'medium' | 'normal' | 'bold';
  applyWeight?: 'medium' | 'normal' | 'bold';
  /** Labels — default to 'Clear' / 'Apply'. */
  clearLabel?: string;
  applyLabel?: string;
  /** Extra classes for the row wrapper. */
  className?: string;
}

/**
 * Atomic Clear/Apply footer row for filter dropdowns and panels.
 * Pairs two FooterActionButtons in the shared spaced row layout,
 * so every footer renders identically with zero duplicated markup.
 */
const FilterFooterActions: React.FC<FilterFooterActionsProps> = ({
  onClear,
  onApply,
  size = 'body',
  clearWeight,
  applyWeight,
  clearLabel = 'Clear',
  applyLabel = 'Apply',
  className = '',
}) => (
  <div
    className={`mt-4 flex items-center justify-between border-t border-gray-100 pt-4 ${className}`}
  >
    <FooterActionButton
      label={clearLabel}
      variant="clear"
      onClick={onClear}
      weight={clearWeight}
      size={size}
    />
    <FooterActionButton
      label={applyLabel}
      variant="apply"
      onClick={onApply}
      weight={applyWeight}
      size={size}
    />
  </div>
);

export default FilterFooterActions;
